import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'features',
    loadComponent: () => import('./features/features-page.component').then(m => m.FeaturesPageComponent)
  },
  {
    path: 'benefits',
    loadComponent: () => import('./benefits/benefits-page.component').then(m => m.BenefitsPageComponent)
  },
  {
    path: 'pricing',
    loadComponent: () => import('./pricing/pricing-page.component').then(m => m.PricingPageComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact-page.component').then(m => m.ContactPageComponent)
  },
  {
    path: 'demo',
    loadComponent: () => import('./demo/demo.component').then(m => m.DemoComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./signup/signup-page.component').then(m => m.SignupPageComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./terms/terms-page.component').then(m => m.TermsPageComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy/privacy-page.component').then(m => m.PrivacyPageComponent)
  },
  {
    path: 'cookie',
    loadComponent: () => import('./cookie/cookie-page.component').then(m => m.CookiePageComponent)
  }
];
